import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

/**
 * Sad icon
 * @param props
 * @constructor
 */
export const Sad: FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 24a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-22.793A10.793 10.793 0 1022.793 12 10.805 10.805 0 0012 1.207z"
          fill="currentColor"
        ></path>
        <path
          d="M18.284 17.409a7.282 7.282 0 00-12.567 0 .603.603 0 001.042.603 6.074 6.074 0 0110.482 0 .604.604 0 001.043-.603zM8.38 9.901a1.509 1.509 0 100-3.017 1.509 1.509 0 000 3.017zM15.622 9.901a1.509 1.509 0 100-3.017 1.509 1.509 0 000 3.017z"
          fill="currentColor"
        ></path>
      </svg>
    </Icon>
  )
}
